import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { AutoCompleteModule } from "@bfx/primeng/autocomplete";
import { ButtonModule } from "@bfx/primeng/button";
import { CheckboxModule } from "@bfx/primeng/checkbox";
import { DataTableModule } from "@bfx/primeng/datatable";
import { DropdownModule } from "@bfx/primeng/dropdown";
import { InputMaskModule } from "@bfx/primeng/inputmask";
import { InputTextModule } from "@bfx/primeng/inputtext";
import { SpinnerModule } from "@bfx/primeng/spinner";
import { ToggleButtonModule } from "@bfx/primeng/togglebutton";

import { BfxSharedModule } from "../bfx-shared/bfx-shared.module";
import { BfxElementsLibraryModule } from "app/bfx-element-library/bfx-elements-library.module";
import { BfxPriceSpinnerComponent } from "./bfx-price-spinner.component";
import { BfxAmountSpinnerComponent } from "./bfx-amount-spinner.component";
import { BfxRateSpinnerComponent } from "./bfx-rate-spinner.component";
import { BfxTemperatureSpinnerComponent } from "./bfx-temperature-spinner.component";
import { BfxContactsInputComponent } from "./bfx-contacts-input.component";
import { BfxSuspendControlComponent } from "./bfx-suspend-control.component";
import { BfxTimeInputComponent } from "./bfx-time-input.component";
import { BfxClientIntentToggleComponent } from "./bfx-toggle-client-intent.component";
import { BfxAutocompleteFavoritesProviderService } from "./services/bfx-autocomplete-favorites-provider.service";
import { BfxAccountLookupMediatorService } from "./services/bfx-account-lookup-mediator.service";
import { NativeDesktopModule } from "../bfx-native-desktop/native-desktop-support.module";
import { BaseComponentsModule } from "../../shared/base-components/base-components.module";
import { BfxPipeModule } from "../bfx-shared/bfx-pipes.module";
import { BfxAlgoStateDropdownComponent } from "app/bfx-interface-controls/bfx-algo-state-dropdown.component";
import { BfxTradeTypeDropdownComponent } from "app/bfx-interface-controls/bfx-trade-type-dropdown.component";

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FlexLayoutModule,
    FormsModule,
    DataTableModule,
    InputTextModule,
    CheckboxModule,
    AutoCompleteModule,
    ButtonModule,
    ToggleButtonModule,
    SpinnerModule,
    DropdownModule,
    InputMaskModule,
    BfxElementsLibraryModule,
    BaseComponentsModule,
    NativeDesktopModule,
    BfxSharedModule,
    BfxPipeModule,
  ],
  declarations: [
    BfxClientIntentToggleComponent,
    BfxPriceSpinnerComponent,
    BfxAmountSpinnerComponent,
    BfxRateSpinnerComponent,
    BfxContactsInputComponent,
    BfxTemperatureSpinnerComponent,
    BfxSuspendControlComponent,
    BfxTimeInputComponent,
    BfxAlgoStateDropdownComponent,
    BfxTradeTypeDropdownComponent,
  ],
  providers: [BfxAutocompleteFavoritesProviderService, BfxAccountLookupMediatorService],
  exports: [
    BfxClientIntentToggleComponent,
    BfxPriceSpinnerComponent,
    BfxAmountSpinnerComponent,
    BfxRateSpinnerComponent,
    BfxContactsInputComponent,
    BfxTemperatureSpinnerComponent,
    BfxSuspendControlComponent,
    BfxTimeInputComponent,
    BfxAlgoStateDropdownComponent,
    BfxTradeTypeDropdownComponent,
  ],
})
export class BfxInterfaceControlsModule {}
